// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1QHUH","boxTitle":"Qualiphy_boxTitle__18ItD","box":"Qualiphy_box__3tTP-","toggleWrap":"Qualiphy_toggleWrap__34RZB"};